var CalculationStatus;
(function (CalculationStatus) {
    CalculationStatus[CalculationStatus["Approved"] = 1] = "Approved";
    CalculationStatus[CalculationStatus["ApprovedDraft"] = 2] = "ApprovedDraft";
    CalculationStatus[CalculationStatus["DraftApprover"] = 3] = "DraftApprover";
    CalculationStatus[CalculationStatus["DraftCreator"] = 4] = "DraftCreator";
    CalculationStatus[CalculationStatus["DraftVerifier"] = 5] = "DraftVerifier";
    CalculationStatus[CalculationStatus["DraftUniversal"] = 6] = "DraftUniversal";
    CalculationStatus[CalculationStatus["RejectedCreator"] = 7] = "RejectedCreator";
    CalculationStatus[CalculationStatus["RejectedCreatorAndVerifier"] = 8] = "RejectedCreatorAndVerifier";
    CalculationStatus[CalculationStatus["Reopened"] = 9] = "Reopened";
    CalculationStatus[CalculationStatus["ToBeApproved"] = 10] = "ToBeApproved";
    CalculationStatus[CalculationStatus["ToBeReopened"] = 11] = "ToBeReopened";
    CalculationStatus[CalculationStatus["ToBeSubmitted"] = 12] = "ToBeSubmitted";
    CalculationStatus[CalculationStatus["ToBeVerified"] = 13] = "ToBeVerified";
    CalculationStatus[CalculationStatus["New"] = 14] = "New";
})(CalculationStatus || (CalculationStatus = {}));
export default CalculationStatus;
